import axios from "axios";

export const baseUrl = ''
export const s3Url = "https://s3.artacloud.ru/lika"
export const apiUrl = baseUrl + '/api'

export const instance = axios.create({
    baseURL: apiUrl,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true
})

export interface CommonResponse<T> extends CommonResponseType {
    data: T
}

export interface CommonResponseType {
    status: number
    message: string
}

export type GetParamsType = {
    limit?: number
    offset?: number
} & BaseRequestParams

export type GetSingleParamsType = {
    id: number
} & BaseRequestParams

export type BaseRequestParams = {
    controller?: AbortController
    withoutLoadingIndicator?: boolean
}
